import React, { useEffect, useState } from "react";

const Greeting = () => {
  const [greeting, setGreeting] = useState("");
  const [city, setCity] = useState("");

  useEffect(() => {
    // 1️⃣ Determine time-based greeting
    const hours = new Date().getHours();
    if (hours < 12) setGreeting("Good morning");
    else if (hours < 18) setGreeting("Good afternoon");
    else setGreeting("Good evening");

    // 2️⃣ Fetch city using IP-based geolocation API
    fetch("https://ipapi.co/json/",{credentials:'include'}) // Free IP geolocation API
      .then((res) => res.json())
      .then((data) => {
        setCity(data.city || "your city");
      })
      .catch(() => setCity("your city")); // fallback if API fails
  }, []);

  return (
    <>
      {greeting}!
    </>
  );
};

export default Greeting;